
document.addEventListener('DOMContentLoaded', function(e) {
  document.getElementsByClassName('js_hamburger')[0].addEventListener('click', function(e) {
    e.preventDefault();
    document.body.classList.toggle('menu-open');
  });

  document.getElementsByClassName('js_menu')[0].addEventListener('click',function(){
    document.body.classList.remove('menu-open');
  });

});
